import { lazy, Suspense } from 'react';
import { Provider } from 'react-redux';
import qs from 'qs';

import { store } from 'store/store';
import { SLOT_QUERY_PARAM_KEY, Slot, SlotQueryParamValues } from 'slots/types';
import LoadingScreen from 'screens/Loading';

const ActionSlot = lazy(() => import('slots/ActionSlot'));
const PostPaymentSlot = lazy(() => import('slots/PostPaymentSlot'));
const UISlot = lazy(() => import('slots/UISlot'));
const SettingsSlot = lazy(() => import('slots/SettingsSlot'));
const VerifyCustomerSlot = lazy(() => import('slots/VerifyCustomerSlot'));

function getSlot() {
  const queryParams = qs.parse(window.location.search, {
    ignoreQueryPrefix: true,
  });
  const slotQueryParam = queryParams[SLOT_QUERY_PARAM_KEY];

  switch (slotQueryParam) {
    case SlotQueryParamValues.ACTION:
      return Slot.ACTION;
    case SlotQueryParamValues.PAY:
      window.location.href = '/checkout';
      return Slot.PAY;
    case SlotQueryParamValues.POST_PAY:
      return Slot.POST_PAY;
    case SlotQueryParamValues.SETTINGS:
      return Slot.SETTINGS;
    case SlotQueryParamValues.VERIFY_CUSTOMER:
      return Slot.VERIFY_CUSTOMER;
    default:
      return Slot.UI;
  }
}

const App = () => {
  const slot = getSlot();

  const getScreen = (slot) => {
    switch (slot) {
      case Slot.ACTION:
        return <ActionSlot />;

      case Slot.PAY:
        return <></>;

      case Slot.POST_PAY:
        return <PostPaymentSlot />;

      case Slot.SETTINGS:
        return (
          <Provider store={store}>
            <SettingsSlot />
          </Provider>
        );

      case Slot.VERIFY_CUSTOMER:
        return <VerifyCustomerSlot />;

      default:
        return (
          <Provider store={store}>
            <UISlot />
          </Provider>
        );
    }
  };

  return (
    <div data-testid={`slot-${slot}`}>
      <Suspense fallback={<LoadingScreen />}>{getScreen(slot)}</Suspense>
    </div>
  );
};

export default App;
